import React, { useState, useEffect } from 'react';
import './App.css';
import logoTransparent from './assets/logoTransparent.png';
import logoText from './assets/logoText.png';
import scanner from './assets/scanner.png';

function App() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="App">
      {/* Header */}
      <header className="main-header">
        <div className="header-container">
          <div className="coming-soon-indicator">
            <span className="indicator-dot"></span>
            <span>Coming Soon</span>
          </div>
        </div>
      </header>

      {/* Enhanced Animated Background */}
      <div className="animated-bg">
        <div className="floating-element element-1"></div>
        <div className="floating-element element-2"></div>
        <div className="floating-element element-3"></div>
        <div className="floating-element element-4"></div>
      </div>

      {/* Main Content */}
      <main className="main-content">
        {/* Hero Section */}
        <section id="hero" className={`hero-section ${isVisible ? 'visible' : ''}`}>
          <div className="hero-container">
            <div className="hero-left">
              <div className="hero-logo-container">
                <img src={logoTransparent} alt="MISVEÉ Logo" className="hero-main-logo" />
                <div className="hero-logo-glow"></div>
              </div>
              
              <div className="hero-content">
                <h1 className="hero-title">
                  Crafting <span className="highlight">Culinary</span><br/>
                  <span className="highlight">Excellence</span> Daily
                </h1>
                
                <p className="hero-description">
                  Experience the perfect blend of traditional artisan techniques
                  and modern culinary innovation at MISVEÉ.
                </p>
              </div>
            </div>

            <div className="hero-right">
              <div className="scanner-showcase">
                <div className="scanner-container">
                  <div className="scanner-frame">
                    <img src={scanner} alt="QR Code Scanner" className="scanner-image" />
                    <div className="scanner-overlay">
                      <div className="scan-line"></div>
                      <div className="corner-indicator top-left"></div>
                      <div className="corner-indicator top-right"></div>
                      <div className="corner-indicator bottom-left"></div>
                      <div className="corner-indicator bottom-right"></div>
                    </div>
                  </div>
                  
                  <div className="scanner-info">
                    <h3 className="scanner-title">Scan & Connect</h3>
                    <p className="scanner-description">
                      {/* While we are crafting the perfect online experience, your sweet cravings can still be fulfilled - order directly */}
                      While we curate the ultimate digital experience, indulge your cravings through direct orders
                    </p>
                    <div className="social-platforms">
                      <span className="platform">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.516"/>
                        </svg>
                        WhatsApp
                      </span>
                      <span className="platform">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                        </svg>
                        Instagram
                      </span>
                      <span className="platform">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                        </svg>
                        Facebook
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </main>

      {/* Footer */}
      <footer className="main-footer">
        <div className="footer-container">
          <div className="footer-top">
            <div className="footer-brand">
              {/* <img src={logoTransparent} alt="MISVEÉ" className="footer-logo" /> */}
              <img src={logoText} alt="MISVEÉ Text" className="footer-text-logo" />
              <p className="footer-tagline">
                Crafting culinary excellence with passion and precision
              </p>
            </div>
            
            <div className="footer-info">
              <div className="footer-section">
                <h4>Coming Soon</h4>
                <p>Premium Artisan Bakery</p>
                <p>Handcrafted with ❤️</p>
              </div>
              
              <div className="footer-section">
                <h4>Connect</h4>
                <p>Follow us for updates</p>
                <p>Pre-orders available</p>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <div className="footer-copyright">
              <p>&copy; 2024 MISVEÉ. All rights reserved.</p>
            </div>
            <div className="footer-social">
              {/* <span className="social-item">📱</span> */}
              {/* <span className="social-item">📷</span> */}
              {/* <span className="social-item">📘</span> */}
            </div>
          </div>
        </div>
        
        <div className="footer-wave">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,60 C150,20 350,100 600,60 C850,20 1050,100 1200,60 L1200,0 L0,0 Z" fill="#008080"></path>
          </svg>
        </div>
      </footer>
    </div>
  );
}

export default App;